import { toast } from "react-toastify";
import { executePost } from "../ServiceMethods";
import { SessionTimeout } from "../ErrorMessages";
import { removeUserCredentials } from "../LocalStorage";

export const GetMarketPlaceMembershipAPI = async (data, cb) => {
  try {
    const getMarketPlaceMembershipAPI = await executePost(
      "/businessUser/marketPlaceMembership",
      data
    );
    const GetMarketPlaceMembershipData = getMarketPlaceMembershipAPI.data
      ? getMarketPlaceMembershipAPI.data
      : [];
    return GetMarketPlaceMembershipData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};

export const ExploreMarketplaceMembershipAPI = async (data, cb) => {
  try {
    const exploreMarketplaceMembershipAPI = await executePost(
      "/businessUser/myProfile/exploreMarketPlace",
      data
    );
    const ExploreMarketplaceMembershipData =
      exploreMarketplaceMembershipAPI.data
        ? exploreMarketplaceMembershipAPI.data
        : [];
    return ExploreMarketplaceMembershipData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};

export const ManageSubscriptionAPI = async (data, cb) => {
  try {
    const ManageSubscriptionAPI = await executePost(
      "/businessUser/manageSubscription",
      data
    );
    const ManageSubscriptionAPIData = ManageSubscriptionAPI.data
      ? ManageSubscriptionAPI.data
      : [];
    return ManageSubscriptionAPIData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
